import { TabIconProps } from '../../interfaces/icons'

const AddIcon = ({ active }: TabIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.35059 10.1133H14.8761M10.1133 5.35059V14.8761"
      stroke="white"
      stroke-width="1.19069"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default AddIcon
